import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentBehaviourAnalytics from "BehaviourAnalytics/routes/StudentBehaviourAnalytics";

export default store => {
  return {
    path: "overview",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "overview" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [StudentBehaviourAnalytics(store)],
  };
};
